<template>
  <div class="search-box" @click="emit('click', $event)">
    <div class="ipt-box">
      <form
        action="javascript:return true"
        @submit.prevent="formSubmit"
      >
        <input
          ref="searchStoreInput"
          v-model="searchText"
          class="searchInput"
          type="search"
          v-bind:placeholder="placeholderTxt"
          @input="entry()"
          :disabled="disInput"
        >
      </form>
      <div class="icon-box">
        <i class="iconfont icon-sousuo icon" />
      </div>
      <div class="mask-box" />
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue';

defineOptions({name: 'SearchStore'});

const props = defineProps({
  disInput: {
    type: Boolean,
    default: true
  },
  clearText: Boolean
});

const emit = defineEmits(['txtdata', 'click']);
const searchStoreInput = ref(null);
const searchText = ref('');
let timer = null;

const placeholderTxt = computed(() => (
  props.disInput ? '请选择城市或打开定位' : '请输入关键词或门店编码'
));

watch(() => props.clearText, value => {
  if (value) {
    searchText.value = '';
    entry();
  }
});

onBeforeUnmount(() => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
});

function getInputRef () {
  return searchStoreInput.value;
}

function setSearchText (text) {
  searchText.value = text || '';
}

function formSubmit () {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  emit('txtdata', searchText.value, {trigger: 'submit'});
}

// 延时搜索
function entry () {
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    emit('txtdata', searchText.value, {trigger: 'input'});
    timer = null;
  }, 500);
}

defineExpose({getInputRef, setSearchText});
</script>
<style scoped>
.search-box {
  height: 100%;
  width: 62%;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 0;
}
.search-box > .ipt-box {
  width: 100%;
  position: relative;
  height: 38px;
  border: 1px solid var(--border-strong);
  border-left: none;
  border-radius: 0 8px 8px 0;
  background: var(--surface-soft);
  padding-top: 0;
  box-sizing: border-box;
  overflow: hidden;
}
.search-box > .ipt-box > form {
  width: 100%;
  height: 100%;
}
.searchInput {
  display: block;
  width: 114.2857%;
  padding-left: 44px;
  padding-right: 16px;
  border: none;
  outline: none;
  border-radius: 0 8px 8px 0;
  box-sizing: border-box;
  font-size: 16px;
  font-family: inherit;
  background: var(--surface-soft);
  color: var(--text-main);
  line-height: 43.4286px;
  height: 43.4286px;
  transform: scale(0.875);
  transform-origin: left top;
}
.searchInput::placeholder {
  color: var(--text-faint);
}
input::-webkit-clear {
  display: none;
}
.search-box > .ipt-box > .icon-box {
  position: absolute;
  top: 0;
  left: 14px;
  margin-left: 0;
  z-index: 50;
  width: 18px;
  height: 38px;
  line-height: 38px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.search-box > .ipt-box > .mask-box {
  display: none;
}
.search-box > .ipt-box > .icon-box > .icon {
  color: var(--text-faint);
  font-size: 18px;
  font-weight: normal;
}
</style>
